<h2>Nouveau camion</h2>
<p>Souhaitez-vous démarrer un nouveau camion ?</p>
<form [formGroup]="startContainerform" (ngSubmit)="onSubmit()">
  <mat-form-field appearance="outline">
    <mat-label>Date de début du container</mat-label>
    <input matInput [matDatepicker]="picker" formControlName="startedOn">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Poids du camion (kg)</mat-label>
    <input matInput type="number" formControlName="weight">
  </mat-form-field>

  <div class="btn_action">
    <button class="back" type="button" (click)="dialog.closeAll()">Annuler</button>
    <button class="confirm" [disabled]="inProgress" type="submit">
      <span *ngIf="!inProgress">Confirmer</span>
      <mat-spinner [diameter]="30" *ngIf="inProgress"></mat-spinner>
    </button>
  </div>
</form>
